"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _palette = require("../../../styles/palette");

var _icons = require("../../../static/icons/icons");

var _style = require("./style");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Promocode = function (_PureComponent) {
  (0, _inherits2["default"])(Promocode, _PureComponent);

  var _super = _createSuper(Promocode);

  function Promocode(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Promocode);
    _this = _super.call(this, props);

    _this.onInputBlur = function () {
      var onInputBlur = _this.props.onInputBlur;
      onInputBlur();
    };

    _this.onInputChange = function (e) {
      var onChange = _this.props.onChange;
      onChange(e.target.value);
    };

    _this.onPressApply = function () {
      var onSubmit = _this.props.onSubmit;
      onSubmit();
    };

    _this.onPressCta = function () {
      var onPressCta = _this.props.onPressCta;
      onPressCta();
    };

    _this.onPressDisapply = function () {
      var onDisapply = _this.props.onDisapply;
      onDisapply();
    };

    _this.inputRef = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Promocode, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var editing = this.props.editing;

      if (!prevProps.editing && editing && this.inputRef.current) {
        this.inputRef.current.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appliedText = _this$props.appliedText,
          applyText = _this$props.applyText,
          ctaText = _this$props.ctaText,
          disapplyCta = _this$props.disapplyCta,
          disapplyText = _this$props.disapplyText,
          editing = _this$props.editing,
          error = _this$props.error,
          promo = _this$props.promo,
          value = _this$props.value;
      return _react["default"].createElement(_style.Wrapper, null, !editing && !promo && !error && _react["default"].createElement(_style.Button, {
        "data-test-id": "promocode",
        onClick: this.onPressCta
      }, ctaText), (editing && !promo || error) && _react["default"].createElement(_style.VerticalContainer, null, _react["default"].createElement(_style.HorizontalContainer, null, _react["default"].createElement(_style.Input, {
        ref: this.inputRef,
        "data-test-id": "promocode-input",
        error: !!error,
        type: "text",
        onBlur: this.onInputBlur,
        onChange: this.onInputChange,
        value: value
      }), _react["default"].createElement(_style.Button, {
        border: true,
        "data-test-id": "promocode",
        onClick: this.onPressApply
      }, applyText)), !!error && _react["default"].createElement(_style.Error, null, error)), promo && _react["default"].createElement(_style.VerticalContainer, null, _react["default"].createElement("div", null, _react["default"].createElement(_style.Button, {
        "data-test-id": "promocode"
      }, _react["default"].createElement(_style.IconStyled, {
        color: _palette.palette.grey,
        icon: _icons.ICONS.CHECKOUTLINE,
        size: 22
      }), _react["default"].createElement(_style.Space, null), appliedText)), _react["default"].createElement(_style.Disapply, null, "".concat(disapplyText, " "), _react["default"].createElement(_style.DisapplyButton, {
        onClick: this.onPressDisapply
      }, disapplyCta))));
    }
  }]);
  return Promocode;
}(_react.PureComponent);

Promocode.propTypes = {
  appliedText: _propTypes["default"].string,
  applyText: _propTypes["default"].string,
  ctaText: _propTypes["default"].string,
  disapplyCta: _propTypes["default"].string,
  disapplyText: _propTypes["default"].string,
  editing: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onDisapply: _propTypes["default"].func,
  onInputBlur: _propTypes["default"].func,
  onPressCta: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  promo: _propTypes["default"].bool,
  value: _propTypes["default"].string
};
Promocode.defaultProps = {
  appliedText: '',
  applyText: '',
  ctaText: '',
  disapplyCta: '',
  disapplyText: '',
  editing: false,
  error: '',
  onChange: function onChange() {},
  onDisapply: function onDisapply() {},
  onInputBlur: function onInputBlur() {},
  onPressCta: function onPressCta() {},
  onSubmit: function onSubmit() {},
  promo: false,
  value: ''
};
var _default = Promocode;
exports["default"] = _default;